import React from 'react'
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"

import BlogHeroMedia from '../../BlogHeroMedia'
import { BlogTags } from '../../BlogInteractionWidget'

import './banner-info.css'

export const BannerContent = ({ post, textLarge, formattedDate }) => {
    return (
        <div className={`banner-info${post.isHeaderDark ? ' dim':' bright'}${textLarge ? ' text--huge':''}`}>
            <h1>{post.title}</h1>
            <p className="mb-0">{formattedDate}</p>
            <p className="mb-0">{post.author}</p>
            <BlogTags tags={post.tags} isCenter={false} />
            {documentToReactComponents(JSON.parse(post.excerpt.raw))}
        </div>
    )
}

export const BannerContentSmall = ({ post, formattedDate }) => {
    return (
        <div className={`banner-info${post.isHeaderDark ? ' dim':' bright'}`}>
            <BlogHeroMedia data={post} className={`text-center`}  template={post.blogTemplate}>
                <h1 className="mb-10" style={{ marginLeft: 'auto', marginRight: 'auto' }}><span className="blog-heading">{post.title}</span></h1>
                <p className="mb-0">{formattedDate}</p>
                <p className="mb-0 text--dark">{post.author}</p>
                <BlogTags tags={post.tags} isCenter={true} />
            </BlogHeroMedia>
        </div>
    )
}